import { Box, Text } from 'braid-design-system';
import type { FC, PropsWithChildren, ComponentProps } from 'react';

import * as styles from './CustomTag.css';

interface CustomTagProps {
  bleed?: boolean;
  size?: ComponentProps<typeof Text>['size'];
}

const CustomTag: FC<PropsWithChildren<CustomTagProps>> = ({
  children,
  bleed = true,
  size,
}) => (
  <Text size={size}>
    <Box
      borderRadius="full"
      display="flex"
      background="neutralLight"
      paddingX="small"
      paddingY="xxsmall"
      className={{ [styles.customTag]: true, [styles.bleed]: bleed }}
      data-cy="custom-skill-pill"
      data-testid="custom-tag"
    >
      {children}
    </Box>
  </Text>
);

export default CustomTag;
